import { styled } from '@mui/material/styles';

export const CarouselContainer = styled('div')({
  position: 'relative',
  width: '100%'
});

export const CarouselContent = styled('div', {
  shouldForwardProp: (props) => props !== 'windowWidth'
})(({ theme, windowWidth }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
  gap: '1rem',

  overflowX: 'auto',
  '&::-webkit-scrollbar': {
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent'
  },

  width: `${windowWidth}px`,
  // <main> padding
  left: '-1rem',
  padding: '0 1rem',

  [theme.breakpoints.up('md')]: {
    gap: '1.5rem',
    width: `calc(${windowWidth}px - 5.75rem)`,
    // 100% - sidebar - <main> padding - parent padding
    left: `calc((${windowWidth}px - 5.75rem) * -0.05 - 3.25rem)`,
    padding: `0 calc((${windowWidth}px - 5.75rem) * 0.05 + 3.25rem)`
  }
}));
